import { Key } from 'ts-keycode-enum';

export class Logger {
  static isDebugEnabled = false;
  static logQueue = [];

  static logEverythingFromQueue = () => {
    if (!Logger.isDebugEnabled) {
      return;
    }

    Logger.logQueue.forEach(({ args = [], serviceName, type }) => console[type](serviceName, ...args));
  };

  private readonly serviceName;

  constructor(serviceName) {
    this.serviceName = serviceName;
  }

  log = (...args) => {
    this.pushToLogQueue(args, 'log');

    if (Logger.isDebugEnabled) {
      console.log(this.serviceName, ...args);
    }
  };

  info = (...args) => {
    this.pushToLogQueue(args, 'info');

    if (Logger.isDebugEnabled) {
      console.info(this.serviceName, ...args);
    }
  };

  warn = (...args) => {
    this.pushToLogQueue(args, 'warn');

    if (Logger.isDebugEnabled) {
      console.warn(this.serviceName, ...args);
    }
  };

  error = (...args) => {
    this.pushToLogQueue(args, 'error');

    if (Logger.isDebugEnabled) {
      console.error(this.serviceName, ...args);
    }
  };

  private pushToLogQueue = (args, type = 'log') =>
    Logger.logQueue.push({
      args,
      type,
      serviceName: this.serviceName,
    });
}

// Show log when CTRL+ALT+SHIFT+L was pressed
const enableDebugHandler = (event) => {
  if (Logger.isDebugEnabled) {
    return;
  }

  const { ctrlKey, shiftKey, metaKey, altKey, keyCode } = event;

  const keyCombination = [(ctrlKey || metaKey) && 'c', altKey && 'a', shiftKey && 's', keyCode]
    .filter(Boolean)
    .join('');

  if (keyCombination !== `cas${Key.L}`) {
    return;
  }

  Logger.isDebugEnabled = true;
  Logger.logEverythingFromQueue();

  detachEnableDebugHandler();
};

export const attachEnableDebugHandler = () => window.addEventListener('keydown', enableDebugHandler, false);
export const detachEnableDebugHandler = () => window.removeEventListener('keydown', enableDebugHandler, false);
